import * as actionTypes from "./actionTypes";
import * as eventTypes from "features/offer/edit/client/verification/eventTypes";
import initialState from "reducers/initialState";

const documentVerificationsReducer = (state = initialState.document.verifications, action) => {
  switch (action.type) {
    case actionTypes.LOAD_DOCUMENT_VERIFICATIONS_STARTED: {
      return {
        ...state,
        [action.id]: {
          loading: true
        }
      };
    }
    case actionTypes.LOAD_DOCUMENT_VERIFICATIONS_SUCCEEDED: {
      return {
        ...state,
        [action.id]: {
          loading: false,
          loaded: true
        }
      };
    }

    case eventTypes.OFFER_PARTNER_VERIFICATIONS_INVALIDATED: {
      const { documentId, siteId } = action.event.eventBody;
      const key = `${documentId}-${siteId}`;
      return {
        ...state,
        [key]: {
          loading: false,
          loaded: false
        }
      };
    }
 
    default:
      return state;
  }
};

export default documentVerificationsReducer;
